import moment from "moment";
import _isEmpty from "lodash/isEmpty";
import { daysLeft } from "@/utils/helpers";

const state = {
    nonfictionMembership: {}
};

const mutations = {
    SET_NONFICTION_MEMBERSHIP(state, nonfictionMembership) {
        state.nonfictionMembership = nonfictionMembership;
    },
    CLEAN_UP_DATA(state) {
        state.nonfictionMembership = {};
    }
};

const actions = {
    getData({ dispatch }) {
        // get the user membership data
        dispatch("updateNonfictionMembership");
    },
    cleanUpData({ commit }) {
        commit("CLEAN_UP_DATA");
    },
    setNonfictionMembership({ commit }, nonfictionMembership) {
        commit("SET_NONFICTION_MEMBERSHIP", nonfictionMembership);
    },
    getNonfictionMembership() {
        return axios.get("/v2/membership/non_fiction");
    },
    updateNonfictionMembership({ dispatch }) {
        return new Promise((resolve) => {
            dispatch("getNonfictionMembership").then(({ data }) => {
                dispatch("setNonfictionMembership", data);
                resolve(data);
            });
        })
    }
};

const getters = {
    hasNonFictionSubscription(state) {
        return !_isEmpty(state.nonfictionMembership);
    },
    getNonFictionSubscriptionDaysLeft(state) {
        let membershipStatusDaysLeft = 0;
        if (!_isEmpty(state.nonfictionMembership)) {
            membershipStatusDaysLeft = daysLeft(moment(), state.nonfictionMembership.last_day || state.nonfictionMembership.renewal_date);
        }
        return membershipStatusDaysLeft;
    },
    hasNonfictionActiveSubscription(state) {
        let isActive = false;
        if (!_isEmpty(state.nonfictionMembership)) {
            isActive = !!(state.nonfictionMembership.renewal_date);
        }
        return isActive;
    },
    // eslint-disable-next-line
    hasNonfictionSubscriptionAccess(state, getters) {
        return getters.getNonFictionSubscriptionDaysLeft > 0;
    },
    // eslint-disable-next-line
    hasActiveSubscription(state, getters) {
        return Boolean(getters.hasNonfictionSubscriptionAccess);
    },
    hasSubscribed(state) {
        return !_isEmpty(state.nonfictionMembership);
    },
    hasMobileNonFictionSubscription(state) {
        let nonFictionSubscription = false;
        if (!_isEmpty(state.nonfictionMembership)) {
            nonFictionSubscription = ["ios", "android"].includes(state.nonfictionMembership.platform);
        }
        return nonFictionSubscription;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
